// import 'jquery-lazy';
import 'slick-carousel';

const $sliderTop = $('.js-slick-slider-top');
const $statusSliderTop = $('.js-slick-slider-top-counter');
const $scrollBelow = $('.js-scroll-below');

$sliderTop.on('init reInit afterChange', (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    $statusSliderTop.text(`${i}/${slick.slideCount}`);
});

if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
    $('.js-slick-slider-top .slider-item').each(function ieFallback() {
        const $container = $(this).find('.slider-item-inner');
        const img = $container.find('img');
        let src = img.attr('data-lazy');

        if ($(this).is($('.slider-item:first-of-type'))) {
            src = img.attr('src');
        }

        $container.attr('data-bg', src);
        img.remove();
    });

    $sliderTop.find('.slider-item:first-of-type').find('.slider-item-inner').Lazy({ attribute: 'data-bg' });
    $sliderTop.find('.slider-item:nth-of-type(2)').find('.slider-item-inner').Lazy({ attribute: 'data-bg' });
}

$sliderTop.slick({
    centerMode: true,
    centerPadding: '0',
    cssEase: 'linear',
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 500,
    prevArrow: $('.js-prev-slide-in-slider-top'),
    nextArrow: $('.js-next-slide-in-slider-top'),
    responsive: [{
        breakpoint: 767,
        settings: {
            autoplay: false,
        }
    }]
});

$($sliderTop).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    if (nextSlide === 0) {
        $('.slider-logo-wrapper').fadeIn(450);

    } else {
        $('.slider-logo-wrapper').fadeOut(450);
    }

    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        $sliderTop.find(`div[data-slick-index="${nextSlide}"]`).find('.slider-item-inner').Lazy({ attribute: 'data-bg' });
        $sliderTop.find(`div[data-slick-index='${nextSlide + 1}']`).find('.slider-item-inner').Lazy({ attribute: 'data-bg' });
    }
});

$scrollBelow.on('click', function scrollBelow(e) {
    e.preventDefault();

    const $this = $(this);

    $('html, body').animate({
        scrollTop: $($this.attr('href')).offset().top - 34
    }, 1000);
});
